export const frontendSkills = [
  { name: "HTML5", level: "Expert" },
  { name: "CSS3", level: "Expert" },
  { name: "JavaScript", level: "Expert" },
  { name: "TypeScript", level: "Advanced" },
  {
    name: "React.js",
    level: "Advanced",
  },
  { name: "Next.js", level: "Advanced" },
  {
    name: "Redux & State Management (Context API, Zustand)",
    level: "Experienced",
  },
  {
    name: "Data Fetching & Caching (React Query, Axios)",
    level: "Experienced",
  },
  {
    name: "Forms & Validation (React Hook Form, Formik, Yup)",
    level: "Experienced",
  },
  { name: "date & time manipulation (Day.js & date-fns)", level: "Advanced" },
  { name: "internationalization (i18next)", level: "Advanced" },
  { name: "Tailwind CSS", level: "Advanced" },
  { name: "Material UI", level: "Advanced" },
  { name: "Styled Components", level: "Advanced" },
  { name: "CSS Modules", level: "Advanced" },
  { name: "Bootstrap", level: "Advanced" },
  { name: "Design Systems (tokens, theming, scalability)", level: "Advanced" },
  {
    name: "Cross-Browser Compatibility",
    level: "Advanced",
  },

  { name: "Animation & Motion (Framer Motion)", level: "Experienced" },
  { name: "Performance Optimization", level: "Experienced" },
  { name: "SEO", level: "Experienced" },
];

export const backendMobileSkills = [
  { name: "React Native / Cross-Platform Apps", level: "Advanced" },
  { name: "Expo", level: "Advanced" },
  {
    name: "Firebase (Auth, Firestore, Functions, Hosting, Messaging)",
    level: "Advanced",
  },
  {
    name: "Mongodb & Mongoose",
    level: "Advanced",
  },
  { name: "Node.js / Express & Serverless Functions", level: "Experienced" },
  { name: "REST & GraphQL API Design & Integration", level: "Experienced" },
  {
    name: "Progressive Web Apps (PWA) & Offline-First Apps",
    level: "Advanced",
  },
  {
    name: "Mobile Performance Optimization & Debugging",
    level: "Advanced",
  },
  {
    name: "Unit & Integration Testing (Jest, React Testing Library)",
    level: "Experienced",
  },
  {
    name: "Authentication & Mobile Security Best Practices",
    level: "Experienced",
  },
  { name: "Push Notifications", level: "Advanced" },
  { name: "Deep Linking", level: "Advanced" },
  {
    name: "CI/CD",
    level: "Experienced",
  },
];
